import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import _ from 'lodash';

import AbsenceRow from './AbsenceRow';
import firebase from '../helpers/firebase';
import { TABLE_NAME } from '../helpers/constants';

const db = firebase.database();

class AbsenceTables extends Component {

  constructor(props) {
    super(props);

    this.state = {
      absences: []
    }

    this.getAbsenceHistory = this.getAbsenceHistory.bind(this);
  }

  componentDidMount() {
    this.getAbsenceHistory();
  }

  getAbsenceHistory() {
    let ref = db.ref(TABLE_NAME.ABSENCES);

    if (this.props.userId) {
      ref = ref.orderByChild('userId').equalTo(this.props.userId);
    }

    ref.on('value', (snapshots) => {

      let absences = [];

      snapshots.forEach((snapshot) => {
        const a = Object.assign({id: snapshot.key}, snapshot.val());
        absences.push(a);
      })
      this.setState({
        absences: _.sortBy(absences, 'startDate').reverse(),
      });
    });
  }

  render() {
    const absences = this.state.absences.map((a) => {
      return (<AbsenceRow key={a.id} absence={a} admin={this.props.admin}/>)
    });

    return <div>
      <h2>Absence History</h2>
      <Table striped bordered condensed hover>
        <thead>
          <tr>
            <th>Type</th>
            {this.props.admin ? <th>Applicant</th> : null}
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {absences}
        </tbody>
      </Table>
    </div>
  }
}

export default AbsenceTables;



// WEBPACK FOOTER //
// ./src/components/AbsenceTables.js